module.exports = __webpack_public_path__ + "img/一星高级大师@3x.9141b96e.png";